import { Component, OnInit } from '@angular/core';
import { DirectoryService } from '../../service/directory/directory.service';
import { Directory } from '../../class/directory';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Employee } from '../../class/employee';


@Component({
  selector: 'app-directorys',
  templateUrl: './directorys.component.html',
  styleUrls: ['./directorys.component.scss']
})
export class DirectorysComponent implements OnInit {

    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    public directorys: Directory[];
    public selectDirectory: Directory;
    public selectEmployee: Employee;
    public directoryID: Number = 0;
    public modNew = false;
    public modView = false;
    public openDirectory = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;

    public form3: FormGroup;
    public employee_id_filter: AbstractControl;
    public department_id_filter: AbstractControl;
    public venue_id_filter: AbstractControl;
    public first = 0;
    public filters: {key: string, value: string}[];

    constructor(
        public directoryService: DirectoryService,
        public confirmationService: ConfirmationService,
        public hasPermissionService: HasPermissionService,
        public translate: TranslateService,

        fb: FormBuilder) {
            this.form3 = fb.group({
                'employee_id_filter': [''],
                'department_id_filter': [''],
                'venue_id_filter': [''],
            });
            this.employee_id_filter = this.form3.controls['employee_id_filter'];
            this.department_id_filter = this.form3.controls['department_id_filter'];
            this.venue_id_filter = this.form3.controls['venue_id_filter'];
        }


    ngOnInit() {
        this.page = 1;
        this.per_page = 10;
        this.filters = [];
        this.filters.push({'key': 'activated', 'value': '1'});
        this.filters.push({'key': 'employee_position_id-not', 'value': '2|31'});
        //this.getDirectorys();
      }

    public loadDirectorysLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort =  '-' + event.sortField;
        } else {
            this.sort =  event.sortField;
        }

        if (event.globalFilter) {
            this.query = event.globalFilter;
        } else {
            this.query = undefined;
        }

        this.sort = '-id';
        this.getDirectorys(event.globalFilter);
    }

    public getDirectorys(query?: string) {
        this.directoryService.getDirectory(this.page, this.per_page, this.sort, query, this.filters).toPromise().then(
            response => {
                this.directorys = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public newDirectory() {
        this.modNew = !this.modNew;
        this.selectDirectory = null;
    }

    public savedDirectory(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectDirectory = null;
        this.modNew = false;
        this.getDirectorys();
    }

    public cancelDirectory (res) {
        this.selectDirectory = null;
        this.modNew = false;
        this.modView = false;
        this.getDirectorys();
    }

    public edit(employee: Employee) {
      this.modNew = true;
      this.selectEmployee = employee;
      this.getDirectorys();
    }

    public view(directory: Directory) {
        this.openDirectory = true;
        this.selectDirectory = directory;
        this.directoryID = directory.id;
        this.modView = true;
    }

    public deleteDialog(directory: Directory) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(directory);
            }
        });
    }

    public delete(directory: Directory) {
        this.directoryService.deleteDirectory(directory.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                this.getDirectorys();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeDirectory(directory: Directory) {
        this.putDirectory(directory);
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }

    public filter (values) {
        this.page = 1;
        this.first = 0;

        this.filters = [];
        this.filters.push({'key': 'activated', 'value': '1'});
        this.filters.push({'key': 'employee_position_id-not', 'value': '2'});
        if (values.employee_id_filter) {
            this.filters.push({'key': 'employee_id-lk', 'value': values.employee_id_filter.id});
        }
        if (values.department_id_filter) {
            this.filters.push({'key': 'department_id-lk', 'value': values.department_id_filter});
        }
        if (values.venue_id_filter) {
            this.filters.push({'key': 'venue_id-lk', 'value': values.venue_id_filter})
        }
        this.getDirectorys();
    }

    public putDirectory(values: Directory) {
        const param = {
            'activated': values.activated
        };
        if (values) {
            const promise = this.directoryService.updateDirectory(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/directorys/directorys.component.ts